<template>
  <div class="card-container1">
    <div class="card-container">
      <div class="card" v-for="(group, index) in featureGroups" :key="index">
        <img :src="group.gif" :alt="group.title" class="card-gif" />
        <h3 class="card-title">{{ group.title }}</h3>
        <p class="card-description">{{ group.description }}</p>
      </div>

      <!-- Botón de venta -->
      <div class="card" style="background-color: #a2c334; color: #ffff">
        <img
          src="../assets/img/adquirir.png"
          class="card-gif"
          style="filter: invert(1)"
        />

        <h3 class="card-title">¡Optimiza tu Taller Hoy!</h3>
        <p class="card-description" style="color: whitesmoke">
          Mejora la gestión de tu taller con OSD. Contáctanos ahora y descubre
          cómo.
        </p>
        <v-btn
          rounded
          style="background-color: #ffff"
          class="mt-2"
          large
          :href="'https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20optimizar%20mi%20taller%20con%20OSD.'"
          target="_blank"
        >
          ¡Lo Quiero!
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import FolioGif from "@/assets/gifs/folio.gif";
import ClientGif from "@/assets/gifs/client1.gif";
import FuelGif from "@/assets/gifs/fuel.gif";
import WorkGif from "@/assets/gifs/work.gif";
import ContractGif from "@/assets/gifs/firma.gif";

export default {
  name: "OSDFeatures",
  data() {
    return {
      featureGroups: [
        {
          gif: FolioGif,
          title: "Automatizaciones",
          description:
            "Incluye funciones como folios automáticos y registro de fechas.",
        },
        {
          gif: ClientGif,
          title: "Datos del Cliente y Vehículo",
          description:
            "Guarda información completa del cliente y especificaciones del vehículo.",
        },
        {
          gif: FuelGif,
          title: "Estado del Vehículo",
          description:
            "Registra el nivel de gasolina y selecciona testigos encendidos.",
        },
        {
          gif: WorkGif,
          title: "Trabajo y Cotización",
          description: "Detalla los trabajos a realizar y genera cotizaciones.",
        },
        {
          gif: ContractGif,
          title: "Contrato y Documentación",
          description:
            "Incluye contrato digital y permite gestionar firmas electrónicas.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.card-container1 {
  width: 100%;
  background-color: #f6f6f6;
}
.card-container {
  width: 85%;
  margin: 0 auto; /* Centra horizontalmente el contenedor */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  padding: 1rem;
  background-color: #f6f6f600;
}

.card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 1rem;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
}

.card-gif {
  max-width: 40%;
  height: auto;
  border-radius: 4px;
  filter: saturate(0.9) hue-rotate(-90deg);
}

.card-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0.5rem 0;
}

.card-description {
  font-size: 0.9rem;
  color: #555;
}
</style>
